export const MENU_ADMIN_LINKS = [
  {
    action: 'mdi-earth',
    title: 'Домены',
    active: false,
    items: [
      { title: 'Карта доменов', link: '/domains/map' },
    ],
  },
  {
    action: 'mdi-view-list',
    title: 'Параметры',
    active: false,
    items: [
      { title: 'Список параметров', link: '/parameters' },
    ],
  },
  {
    action: 'mdi-view-dashboard',
    title: 'Территории',
    active: false,
    items: [
      { title: 'Все территории', link: '/managedpresets/list' },
    ],
  },
  {
    action: 'mdi-folder-account',
    title: 'Договоры',
    active: false,
    items: [
      { title: 'Все договоры', link: '/contracts' },
      { title: 'Добавить договор', link: '/contract/add' },
      { title: 'Биллинг', link: '/billing' },
      { title: 'Пользователи', link: '/users' },
    ],
  },
  {
    action: 'mdi-weather-partly-snowy-rainy',
    title: 'Радары',
    active: false,
    items: [
      { title: 'Просмотр радаров', link: '/radars/viewer' },
      { title: 'Биллинг', link: '/radars/user' },
      { title: 'Все договоры', link: '/radar/contracts' },
      { title: 'Добавить договор', link: '/radar/contract/add' },
    ],
  },
  {
    action: 'mdi-weather-sunny',
    title: 'Синоптика',
    active: false,
    items: [
      { title: 'Данные', link: '/synop' },
      { title: 'Добавить договор', link: '/synop/contract/add' },
      { title: 'Все договоры', link: '/synop/contracts' },
    ],
  },
  {
    action: 'mdi-map',
    title: 'Карты',
    active: false,
    items: [
      { title: 'Просмотр карт', link: '/geomap/viewer' },
      { title: 'Договоры', link: '/geomap/contracts' },
      { title: 'Добавить договор', link: '/geomap/contract/add' },
      { title: 'Биллинг', link: '/geomap/statistics' },
    ],
  },
  {
    action: 'mdi-desktop-mac',
    title: 'Консоль',
    active: false,
    items: [
      { title: 'Прогноз для территорий', link: '/forecast/preset' },
      { title: 'Прогноз в точке', link: '/forecast/point' },
      { title: 'Долгосрочные прогнозы', link: '/forecast/long' },
      { title: 'Долгосрочные прогнозы для территорий', link: '/forecast/long/preset' },
      { title: 'Реанализ', link: '/reanalys' },
      { title: 'Реанализ для территорий', link: '/reanalyspreset' },
    ],
  },
]

export const MENU_USER_LINKS = [
  {
    action: 'mdi-view-dashboard',
    title: 'Прогнозы',
    active: false,
    items: [
      { title: 'Мои территории', link: '/presets/list' },
      { title: 'Заказать территорию', link: '/orderpresets/add' },
      { title: 'Биллинг', link: '/billing/user' },
    ],
  },
]

export const MENU_RADAR_LINKS = [
  {
    action: 'mdi-view-dashboard',
    title: 'Радары',
    active: false,
    items: [
      { title: 'Радары', link: '/radars/user' },
    ],
  },
]